module.exports = __webpack_public_path__ + "img/vip1.71a04586.jpg";